import React from 'react';
import classnames from 'classnames';
import s from './AvatarPlaceholder.scss';
const AvatarPlaceholder = ({ className, isGroup, width, height, 'aria-hidden': ariaHidden, alt })=>{
    const icon = isGroup ? /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: s['icon']
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.975 6.975a3.975 3.975 0 11-7.95 0 3.975 3.975 0 017.95 0zM6.21 4.5c.2 0 .395.017.584.048a5.592 5.592 0 00-.723 2.76c0 1.518.601 2.895 1.58 3.906A3.51 3.51 0 116.21 4.5zM5.438 13.5l1.372.013c.283.003.47.293.357.552l-2.282 5.203a.394.394 0 01-.36.236H3.098a.699.699 0 01-.494-.197c-.273-.27-.62-.645-.85-.907-.174-.196-.186-.427-.056-.654l2.214-3.857a.75.75 0 01.64-.376l.885-.013zM9.555 13.968a.747.747 0 01.687-.45h3.519a.75.75 0 01.686.449l2.27 5.153a.75.75 0 01-.049.696l-.51.828a.75.75 0 01-.639.356H8.481a.75.75 0 01-.638-.356l-.501-.813a.769.769 0 01-.045-.722c.51-1.124 1.772-4.023 2.258-5.14zM18.563 13.5l-1.373.013a.394.394 0 00-.357.552l2.283 5.203a.394.394 0 00.36.236h1.425a.699.699 0 00.494-.197c.273-.27.62-.645.851-.907.174-.196.186-.427.055-.654l-2.213-3.857a.75.75 0 00-.64-.376l-.885-.013zM17.79 4.5c-.2 0-.394.017-.584.048.46.815.724 1.757.724 2.76a5.599 5.599 0 01-1.58 3.906A3.51 3.51 0 1017.79 4.5z"
    })) : /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 23 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: s['icon']
    }, /*#__PURE__*/ React.createElement("title", null, alt), /*#__PURE__*/ React.createElement("path", {
        d: "M11.6365 12.2222C15.0115 12.2222 17.7476 9.48618 17.7476 6.11111C17.7476 2.73604 15.0115 0 11.6365 0C8.2614 0 5.52536 2.73604 5.52536 6.11111C5.52536 9.48618 8.2614 12.2222 11.6365 12.2222Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.52536 14.6667C2.8253 14.6667 0.636475 16.8555 0.636475 19.5556V20.3704C0.636475 21.2704 1.36608 22 2.2661 22H21.0068C21.9069 22 22.6365 21.2704 22.6365 20.3704V19.5556C22.6365 16.8555 20.4476 14.6667 17.7476 14.6667H5.52536Z"
    }));
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isGroup && s['is-group'], className),
        style: {
            width,
            height
        },
        "aria-hidden": ariaHidden
    }, icon);
};
AvatarPlaceholder.displayName = 'AvatarPlaceholder';
export default AvatarPlaceholder;
